import { render, staticRenderFns } from "./r-booster-kind.vue?vue&type=template&id=3749a566"
import script from "./r-booster-kind.vue?vue&type=script&lang=js"
export * from "./r-booster-kind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3749a566')) {
      api.createRecord('3749a566', component.options)
    } else {
      api.reload('3749a566', component.options)
    }
    module.hot.accept("./r-booster-kind.vue?vue&type=template&id=3749a566", function () {
      api.rerender('3749a566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/booster/r-booster-kind.vue"
export default component.exports